import { ElementRef, Injectable } from "@angular/core";
import { TableData } from "app/components/class/table-data";
import { SingService } from "app/components/service/sing.service";
import { Broadcaster } from "app/components/service/Broadcaster";
import { Rooftop } from "app/components/app/class/rooftop";
import { getSelectedRofftop } from "app/components/class/broadcaster/app/get-selected-rofftop";
import { updateRooftops } from "app/components/class/broadcaster/update-rooftops";
@Injectable()
export class ExportPdfService {
    tableData: TableData = new TableData();
    mediaCategories:Array<String> = [];
    countCategories:number = 0;
    ErrorBudgetFile: string = "Budget not found";
    rooftops: Array<Rooftop> = [];
    constructor(private elRef: ElementRef,private httpService: SingService,private broadcaster: Broadcaster) {

    }
    public onInit() {
        this.broadcaster.on<any>("updateSettings").subscribe((data:TableData) => {
            this.tableData.setData(data.settings);
          
        });
        this.broadcaster.on<any>("updateMediaCategories").subscribe((data:Array<String>) => {
            this.mediaCategories = data;
          
          
        });
        this.broadcaster.on<any>("getSelectedRofftop").subscribe((data:getSelectedRofftop) => {
            this.rooftops = data.rooftops;
 
         });
        
         this.broadcaster.on<any>("updateRooftops").subscribe((data:updateRooftops) => {
                 this.rooftops = data.rooftops;
         });
    }
    public show () {
        this.elRef.nativeElement.querySelector(".export-pdf-fon").style.display = "block";
        this.elRef.nativeElement.querySelector(".export-pdf-fon").style.top = `${(document.documentElement.clientHeight / 2) - (this.elRef.nativeElement.querySelector(".export-pdf-fon").offsetHeight / 2)}px`;
    
        (<HTMLElement>document.body.querySelector(".allwhite")).style.display = "block";
        document.body.querySelector("main").classList.add("m--blur");
    }
    public closed() {
        this.elRef.nativeElement.querySelector(".export-pdf-fon").style.display = "none";
        (<HTMLElement>document.body.querySelector(".allwhite")).style.display = "none";
        document.body.querySelector("main").classList.remove("m--blur");
    }
    public getPDFCalendar (productCategoryId:String,dealerships:String) {
       return this.httpService
        .getPDFCalendar({
            dealerGroupId: this.tableData.settings.dealerGroupId,
            year: this.tableData.settings.year,
            month: this.tableData.settings.month,
            budget: this.elRef.nativeElement.querySelector("input[name='budget_pdf']:checked").value,
            dealerships: dealerships,
            productCategoryId: productCategoryId
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/export-pdf/services/export-pdf.service.ts